export default function Footer() {
  return (
    <footer className="site-footer">
      © {new Date().getFullYear()} Forget-IT — Lukas Otterström IT-Konsultation. Org-nummer: 559568-5917
    </footer>
  );
}
